import { createI18n } from 'vue-i18n'
import { messages } from '../locales/index.js'
import { getI18nLocale, userLocale } from './languages.js'
import { deepMerge } from './utils.js'

const coverMessage = (messages) => {
  try {
    const patchFile = require('@/i18n/index.js')
    return deepMerge(messages, patchFile.default, { scope: 'patch' })
  } catch {
    return messages
  }
}

const i18n = createI18n({
  locale: getI18nLocale(userLocale),
  fallbackLocale: getI18nLocale(userLocale),
  messages: coverMessage(messages),
})

export default i18n
